import React from 'react';
import * as S from './Loading.style';
export const Loading = () => React.createElement(S.Loading, null,
    React.createElement("div", { className: "spinner", "data-testid": "loading" }));
//# sourceMappingURL=Loading.js.map